export default __webpack_public_path__ + "static/media/kasparov.8ba065e7.jpeg";